// extracted by mini-css-extract-plugin
export var background = "_63-0";
export var container = "_63-1";
export var contentItem = "_63-7";
export var extendedWarranty = "_63-5";
export var link = "_63-d";
export var modal = "_63-b";
export var modalCloseButton = "_63-9";
export var modalContent = "_63-3";
export var modalContentMain = "_63-6";
export var modalImageLogo = "_63-8";
export var modalLogo = "_63-a";
export var modalSideImage = "_63-4";
export var preview = "_63-c";
export var redoModal = "_63-2";